import i18n from '../../../i18n';
import { useMemo } from 'react';

const VIDEO_URL = 'https://youtu.be/aIHdFlPiIYQ';
const EN_VIDEO_URL = 'https://youtu.be/gnbpAT1x7AE';

function useVideoLink(): string {
    const {
        i18n: { language },
    } = i18n.useTranslation();
    return useMemo(() => (language === 'ru' ? VIDEO_URL : EN_VIDEO_URL), [language]);
}

export default useVideoLink;
